<template>
    <div style="display: flex; align-items: flex-start;">
        <el-input
            v-model="form_data.note"
            type="textarea"
            :rows="4" />
        <btn 
            cssClass="btn btn-secondary" 
            icon="far fa-sticky-note" 
            :click="saveNote" 
            style="margin-left: 10px"
        >Save</btn>
    </div>
</template>

<script>
    export default {
        props: [
            'driver_id',
            'note'
        ],
        data() {
            return {
                form_data: {
                    note: _.cloneDeep(this.note)
                }
            }
        },
        watch: {
            note() {
                this.form_data.note = _.cloneDeep(this.note);
            }
        },
        methods: {
            saveNote() {
                return axios.post(url(`admin/driver/${this.driver_id}/note`), this.form_data)
                .then(() => {
                    this.$emit('updated');
                });
            }
        }
    }
</script>